import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { formatPrice } from "../utils/helpers";
import ChatModal from "../components/ChatModal";

export default function Messages() {
  const { currentUser, getMyChats } = useApp();
  const [openChatId, setOpenChatId] = useState(null);
  const myChats = getMyChats();

  if (!currentUser) return null;

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Mensajes</h1>
      {myChats.length === 0 ? (
        <div style={s.empty}>
          <span style={{fontSize:56}}>💬</span>
          <p style={s.emptyTitle}>No tenes mensajes todavia</p>
          <p style={s.emptyText}>Cuando alguien te contacte por un producto, aparecera aca.</p>
        </div>
      ) : (
        <div style={s.list}>
          {myChats.map(chat => {
            const otherName = currentUser.id === chat.sellerId ? chat.buyerName : chat.sellerName;
            const unread = chat.messages.filter(m => m.senderId !== currentUser.id && !m.read).length;
            const lastMsg = chat.messages[chat.messages.length - 1];
            return (
              <div key={chat.id} style={{...s.chatItem,...(unread>0?s.chatUnread:{})}} onClick={() => setOpenChatId(chat.id)}>
                <div style={s.chatAvatar}>{otherName.charAt(0).toUpperCase()}</div>
                <div style={s.chatInfo}>
                  <div style={s.chatTop}>
                    <p style={s.chatName}>{otherName}</p>
                    {unread > 0 && <span style={s.unreadBadge}>{unread}</span>}
                  </div>
                  <p style={s.chatProduct}>📦 {chat.productTitle} — {formatPrice(chat.productPrice)}</p>
                  {lastMsg && <p style={s.chatLast}>{lastMsg.senderId === currentUser.id ? "Vos: " : ""}{lastMsg.text}</p>}
                  {!lastMsg && <p style={s.chatLast}>Iniciaste una conversacion</p>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {openChatId && <ChatModal chatId={openChatId} onClose={() => setOpenChatId(null)} />}
    </div>
  );
}

const s = {
  page:{maxWidth:700,margin:"0 auto",padding:"32px 20px"},
  heading:{fontSize:24,fontWeight:600,marginBottom:20},
  empty:{textAlign:"center",padding:"80px 0",display:"flex",flexDirection:"column",alignItems:"center",gap:12},
  emptyTitle:{fontSize:18,fontWeight:500,color:"#333"},
  emptyText:{fontSize:14,color:"#888"},
  list:{display:"flex",flexDirection:"column",gap:8},
  chatItem:{background:"#fff",padding:"16px 20px",display:"flex",gap:14,alignItems:"center",cursor:"pointer",borderRadius:12,border:"0.5px solid #e0e0e0"},
  chatUnread:{borderColor:"#1D9E75",background:"#f0faf6"},
  chatAvatar:{width:46,height:46,borderRadius:"50%",background:"#E1F5EE",color:"#0F6E56",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:600,flexShrink:0},
  chatInfo:{flex:1,minWidth:0},
  chatTop:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3},
  chatName:{fontWeight:500,fontSize:15,color:"#111"},
  unreadBadge:{background:"#1D9E75",color:"#fff",borderRadius:20,padding:"2px 8px",fontSize:11,fontWeight:600},
  chatProduct:{fontSize:12,color:"#888",marginBottom:3},
  chatLast:{fontSize:13,color:"#555",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},
};
